import { useMemo } from 'react';

/**
 * Custom hook to detect if the user is using use an in-app browsers.
 *
 * Currently, it's only scoping for Instagram and LINE in-app browsers.
 * We may extend this in the future if needed (e.g. Facebook).
 *
 * Why detect in-app browsers?
 * To avoid issued with some in-app browser's UI covering the bottom part of page in some cases.
 *
 * Here are some references for user agent strings, extracted from Sentry:
 *
 * Mozilla/5.0 (iPhone; CPU iPhone OS 18_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/23A355 Instagram 403.0.0.28.80 (iPhone15,4; iOS 26_0_1; ja_JP; ja; scale=3.00; 1179x2556; IABMV/1; 808786605)
 * Mozilla/5.0 (iPhone; CPU iPhone OS 18_6_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Safari Line/15.17.1
 *
 * @returns {boolean} TRUE if the user agent contains "Instagram" or "Line/"
 */
function useIsInAppBrowser(): boolean {
  return useMemo(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    const userAgent = navigator.userAgent || '';

    // Check for Instagram in-app browser
    const isInstagram = /Instagram/i.test(userAgent);

    // Check for LINE in-app browser (looking for "Line/" pattern)
    const isLine = /Line\//i.test(userAgent);

    return isInstagram || isLine;
  }, []);
}

export default useIsInAppBrowser;
